import {Badge, Icon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {BUYER_PAYMENT_STATUS_CONFIG} from '../config/buyers.config';

import type {BuyerPaymentStatus} from '../types/buyers.types';
import type {ComponentProps, FC} from 'react';

type BadgeSize = NonNullable<ComponentProps<typeof Badge>['size']>;

/** Icon grows a half-step with each badge size — sm stays size-3 to match the existing default look. */
const ICON_SIZE: Record<BadgeSize, string> = {
  xs: 'size-2.5',
  sm: 'size-3',
  md: 'size-3.5',
  lg: 'size-4'
};

export interface BuyerPaymentStatusBadgeProps {
  status: BuyerPaymentStatus;
  size?: BadgeSize;
}

export const BuyerPaymentStatusBadge: FC<BuyerPaymentStatusBadgeProps> = ({
  status,
  size = 'sm'
}) => {
  const {t} = useTranslation('trustAccounts');
  const config = BUYER_PAYMENT_STATUS_CONFIG[status];

  return (
    <Badge variant={config.variant} size={size}>
      <Icon name={config.icon} className={ICON_SIZE[size]} />
      {t(config.labelKey)}
    </Badge>
  );
};
